import { StoreContractorModelType } from './types';
import { sharingDocumentModel } from './sharing-document-model';

export const storeContractorModel: StoreContractorModelType = {
    sharingDocument: sharingDocumentModel,
};
